import { RestClientAuthenticated } from '../network';
import { RenvoiCodeActivationDTO } from './types/activation/RenvoiCodeActivationDTO';
import { TokenNotificationDTO } from './types/activation/TokenNotificationDTO';
import { ActivationDTO } from './types/activation/ActivationDTO';
import { ActivationResponseDTO } from './types/activation/ActivationResponseDTO';
import { SingleFieldDTOString } from './types/SingleFieldDTOString';
import { SingleFieldDTOInteger } from './types/SingleFieldDTOInteger';
import { EvolutionCompteDTO } from './types/activation/EvolutionCompteDTO';
import { ResponseDTO } from './types/ResponseDTO';
import { ListPersonneActivationDedoublonnage } from './types/ListPersonneActivationDedoublonnage';

const activationApi = {
  demandeRenvoiCodeActivation: (activationCode: RenvoiCodeActivationDTO): Promise<ResponseDTO> => new RestClientAuthenticated('/activation/resend', 'POST')
    .jsonBody(activationCode)
    .execute(),
  isIdsValid: (activationIds: ActivationDTO): Promise<ResponseDTO> => new RestClientAuthenticated('/activation/isIdValid', 'POST').jsonBody(activationIds).execute(),
  isConnexionIdsValid: (connexionIds: ActivationDTO): Promise<ResponseDTO> => new RestClientAuthenticated('/activation/isConnexionIdsValid', 'POST').jsonBody(connexionIds).execute(),
  findDuplicates: (activationIds: ActivationDTO): Promise<ListPersonneActivationDedoublonnage> => new RestClientAuthenticated('/activation/duplicates', 'POST').jsonBody(activationIds).execute(),
  finish: (tokenNotification: TokenNotificationDTO): Promise<ActivationResponseDTO> => new RestClientAuthenticated('/activation/finish', 'POST')
    .jsonBody(tokenNotification)
    .execute(),
  initActivationPro: (activation: ActivationDTO): Promise<ActivationResponseDTO> => new RestClientAuthenticated('/activation/pro/init', 'POST')
    .jsonBody(activation)
    .execute(),
  isValidToken: (fieldDTOString: SingleFieldDTOString): Promise<SingleFieldDTOInteger> => new RestClientAuthenticated('/activation/isValidToken', 'POST')
    .jsonBody(fieldDTOString)
    .execute(),
  migratePro: (evolutionCompte: EvolutionCompteDTO): Promise<ActivationResponseDTO> => new RestClientAuthenticated('/activation/pro/migration', 'POST')
    .jsonBody(evolutionCompte)
    .execute(),
  getRecaptchaKey: (): Promise<{ value: string }> => new RestClientAuthenticated('/recatpcha', 'POST').execute(),
};
export default activationApi;
